<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">
                            <h4 class="">Update Members</h4>
                            <div class="card">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <!-- <h4 class="text-center">Member</h4> -->
                                            <b-form-group label="Practice ID" label-for="Practice ID">
                                                <b-form-input type="text" disabled id="PracticeID" name="Practice ID"
                                                    autocomplete="Practice ID" placeholder="Practice ID"
                                                    v-model="form.PracticeID" aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <!-- <h4 class="text-center">Referrals</h4> -->
                                            <b-form-group label="UserID" label-for="UserID">
                                                <b-form-input type="text" disabled id="ID" name="ID" autocomplete="UserID"
                                                    placeholder="UserID" v-model="form.UserID"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">

                                        <div class="col-md-4 col-sm-6">
                                            <h4 class="text-center">Member</h4>

                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <h4 class="text-center">Referrals</h4>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="FirstName" label-for="FirstName">
                                                <b-form-input type="text" id="FirstName" name="FirstName"
                                                    autocomplete="FirstName" placeholder="First Name"
                                                    v-model="form.FirstName"
                                                    :state="$v.form.FirstName.$dirty ? !$v.form.FirstName.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Last Name" label-for="LastName">
                                                <b-form-input type="text" id="LastName" name="LastName"
                                                    autocomplete="LastName" placeholder="Last Name" v-model="form.LastName"
                                                    :state="$v.form.LastName.$dirty ? !$v.form.LastName.$error : null"
                                                    aria-describedby="input-1-live-feedback">
                                                </b-form-input>
                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                    field.
                                                </b-form-invalid-feedback>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Referred By" label-for="ReferredBy">
                                                <b-form-select name="ReferredBy" v-model="form.ReferredBy"
                                                    :options="ReferredByOptions" class="mb-3" value-field="item"
                                                    text-field="name">
                                                </b-form-select>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group id="ReferralDate" label="Referral Date" label-for="ReferralDate">
                                                <b-form-input id="ReferralDate" type="datetime-local"
                                                    v-model="form.ReferralDate"></b-form-input>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-4 col-sm-6">
                                            <b-form-group label="Referral Notes" label-for="ReferralNotes">
                                                <b-form-textarea id="ReferralNotes" v-model="form.ReferralNotes"
                                                    placeholder="Enter something..." rows="3" max-rows="6">
                                                </b-form-textarea>
                                            </b-form-group>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span>Submit</span>
                                            </b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import moment from 'moment'

export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            ReferredByOptions: [{ item: 0, name: 'Select Referral By' }],
            form: {
                id: '',
                FirstName: '',
                UserID: '',
                LastName: '',
                PracticeID: '',
                ReferralDate: '',
                ReferralNotes: '',
                MembershipDate: '',
                ReferredBy: 0,
            },

            isDisabled: false,
            member: {},
        };
    },
    validations: {
        form: {
            FirstName: {
                required,
            },
            LastName: {
                required,
            },
        }
    },
    mounted() {
        this.editMember();
        this.getReferrals();
    },
    methods: {
        onSubmit() {
            this.$v.form.$touch();
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
            let date = moment(this.form.ReferralDate).format('Y-MM-D hh:mm');
            API.UpdateReferred({ ...this.form, ...{ ReferralDate: date } },
                data => {
                    this.isDisabled = false;
                    if (!this.form.id) {
                        if (data.status === 410) {
                            this.errorMsg(data.message)
                        } else {
                            this.$showNotification(data, "success")
                            this.$router.push({ name: 'ViewReferrals' })
                        }
                    } else {
                        if (data.status === 200) {
                            this.$showNotification(data, "success")
                            this.$router.push({ name: 'ViewReferrals' })
                        } else {
                            this.errorMsg('Please try again.')
                        }

                    }
                },
                err => {
                    this.isDisabled = false;
                    this.errorMsg(err);
                }
            )
        },
        getReferrals() {
            API.getReferrals(
                data => {
                    console.log(data);
                    data.data.forEach((user) => {
                        this.ReferredByOptions.push({
                            item: user.UserID,
                            name: user.FirstName + ' ' + user.LastName,
                        });
                    });
                }, err => {
                })
        },
        editMember() {
            if (this.$route.params.id != undefined || this.$route.params != '') {
                if (this.$route.params.user) {
                    this.form = this.$route.params.user;
                    console.log(this.form)
                } else {
                    this.$router.push({ name: 'ViewReferrals' })
                }
            }
        },
        errorMsg(err) {
            console.log(err);
            this.$showNotification({ message: 'Failed system error' }, "error")
        }
    }, computed: {},
}
</script>
